<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-coins"></i> {{title | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <i aria-hidden="true">&times;</i>
    </button>
  </div>
  <div class="modal-body">
    <div class="">
      <div class="row">
        <div class="col-md-6 w-100">
          <div class="row mr-18">
            <dt class="col-md-3 p-r-0"><strong>{{ "LABEL.ENTERPRISE" | translate }}
            </strong></dt>
            <div class="col-md-1 mr-lr">:</div>
            <div class="col-md-8">
              <span style="color: #ee1818" class="mr-left-0">{{ iofFirstDetail.enterpriseName }} </span>
            </div>
          </div>
          <div class="row mr-18">
            <dt class="col-md-3 p-r-0"><strong>{{ "LABEL.FLOW" | translate }}</strong></dt>
            <div class="col-md-1 mr-lr">:</div>
            <div class="col-md-8"><span>{{ iofFirstDetail.workflowDescription }}</span></div>
          </div>

          <div class="row mr-18">
            <dt class="col-md-3 p-r-0"><strong>{{ "LABEL.SERVICE" | translate }}</strong></dt>
            <div class="col-md-1 mr-lr">:</div>
            <div class="col-md-8"><span>{{ serviceName }}</span></div>
          </div>
        </div>

        <div class="col-md-6 w-100">
          <div class="row">
            <dt class="col-md-3 p-r-0"><strong>Ruc</strong></dt>
            <div class="col-md-1 mr-lr">:</div>
            <div class="col-md-8"><span>{{ iofFirstDetail.ruc }}</span></div>
          </div>
          <div class="row mr-18">
            <dt class="col-md-3 p-r-0"><strong>{{ "LABEL.QUANTITY" | translate }}</strong></dt>
            <div class="col-md-1 mr-lr">:</div>
            <div class="col-md-8"><span>{{ iofFirstDetail.quantity }}</span></div>
          </div>
          <div class="row mr-18">
            <dt class="col-md-3 p-r-0"><strong>{{ "LABEL.DATE-RANGE" | translate }}</strong></dt>
            <div class="col-md-1 mr-lr">:</div>
            <div class="col-md-8">
              <span> {{ "LABEL.FROM" | translate }} {{this.formatter.format(from)}} {{ "LABEL.TO" | translate }} {{this.formatter.format(to)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive mt-2 mb-2 custom-table-height">
      <table class="table-sm table-bordered">
        <thead>
        <tr>
          <th scope="col" title="#"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.YEAR' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.MONTH' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.SUBJECT' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService()"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.LOAD-DATE' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService()"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.RESPONSIBLE' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService()"></th>
          <th scope="col" title="{{ getDescriptionDate() | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService() && !isReviewService()"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.RESPONSIBLE' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService() && isReviewService()"></th>
          <th scope="col" title="{{ getOperation() | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService() && !isReviewService()"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.REVIEWER' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService() && isReviewService()"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.NOTIFICATION-SENT-TO' | translate }}"
              *ngIf="isSendElectronicNotificationService() || isSendEmailService()"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.COPY' | translate }}" *ngIf="isSendEmailService()"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.DATE-SENT' | translate }}"
              *ngIf="isSendElectronicNotificationService() || isSendEmailService()"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.DATE-CREATED' | translate }}"
              *ngIf="isSendElectronicNotificationService() || isSendEmailService()"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let iofSecondDetail of iofSecondDetails; let index=index">
          <td title="#"><strong>{{(page.number * pageNumber) + index + 1}}</strong></td>
          <td title="{{ 'TABLE.HEADER.YEAR' | translate }}">{{iofSecondDetail.year}}</td>
          <td title="{{ 'TABLE.HEADER.MONTH' | translate }}">{{iofSecondDetail.monthName}}</td>
          <td title="{{ 'TABLE.HEADER.SUBJECT' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService()">{{iofSecondDetail.documentSubject}}</td>
          <td title="{{ 'TABLE.HEADER.LOAD-DATE' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService()">{{iofSecondDetail.loadDate}}</td>
          <td title="{{ 'TABLE.HEADER.RESPONSIBLE' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService()">{{iofSecondDetail.uploaderName}}</td>
          <td title="{{ getOperation() | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService() && !isReviewService()">{{iofSecondDetail.signatureDate}}</td>
          <td title="{{ 'TABLE.HEADER.RESPONSIBLE' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService() && isReviewService()">{{iofSecondDetail.signatureDate}}</td>
          <td title="{{ 'TABLE.HEADER.REVIEWER' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService() && !isReviewService()">{{iofSecondDetail.signer}}</td>
          <td title="{{ 'TABLE.HEADER.REVIEWER' | translate }}"
              *ngIf="!isSendElectronicNotificationService() && !isSendEmailService() && isReviewService()">{{iofSecondDetail.signer}}</td>
          <td title="{{ 'TABLE.HEADER.NOTIFICATION-SENT-TO' | translate }}"
              *ngIf="isSendElectronicNotificationService() || isSendEmailService()">{{iofSecondDetail.recipient}}</td>
          <td title="{{ 'TABLE.HEADER.COPY' | translate }}" *ngIf="isSendEmailService()">{{iofSecondDetail.copy}}</td>
          <td title="{{ 'TABLE.HEADER.DATE-SENT' | translate }}"
              *ngIf="isSendElectronicNotificationService() || isSendEmailService()">{{iofSecondDetail.sentAt}}</td>
          <td title="{{ 'TABLE.HEADER.DATE-CREATED' | translate }}"
              *ngIf="isSendElectronicNotificationService() || isSendEmailService()">{{iofSecondDetail.createAt}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <nav class="Page navigation pagination-custom">
      <div class="row">
        <div class="col-md-8 mt-1">
          <div class="justify-content-row">
            <label class="mr-1 font-weight-normal">Mostrar </label>
            <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                    (ngModelChange)="loadDetails(enumPage.First)">
              <option *ngFor="let page of pageNumbers" [value]="page.value"
                      class="font-weight-bold">{{page.value}}</option>
            </select>
            <label class="font-weight-normal"> registros.</label>
          </div>
          <div class="page-total-entries">
            {{ "LABEL.TOTAL-RECORDS" | translate }}
            : {{iofSecondDetails.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
          </div>
        </div>
        <div class="col-md-4">
          <ul class="pagination justify-content-end text-center">
            <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
              <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadDetails(enumPage.First)"
                 tabindex="-1" aria-disabled="true">
                <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
                {{ "BUTTON.FIRST" | translate }}
              </a>
            </li>
            <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
              <a class="left {{page.number == 0 ? 'disabled' : ''}}"
                 (click)="loadDetails(enumPage.Previous)">
                <i class="fa fa-angle-left" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
              <a class="right" (click)="loadDetails(enumPage.Next)"><i
                class="fa fa-angle-right" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
              <a class="next" (click)="loadDetails(enumPage.Last)">
                {{ "BUTTON.LAST" | translate }}
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-success dxbs-button"
            (click)="downloadOf()">
      <i aria-hidden="true" class="image far fa-file-excel"></i>
      {{ "BUTTON.EXPORT" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="accept()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.ACCEPT" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
